// Unpublished Work © 2020-2024 Deere & Company.

import React from 'react';
import {adaptBusinessActivities} from '../repositories/adapters/configuration';
import {postLoadedMessage} from '../services/post-message-helper';
import {setConfiguration} from '../action-creators/configuration';
import {setCustomerIds} from '../action-creators/customer-ids';
import {useDispatch} from 'react-redux';
import {useOktaAuth} from '@okta/okta-react';

const parseId = (id) => id ? parseInt(id, 10) : 0;

export const ConfigListenerProvider = ({children}) => {
    const {authState} = useOktaAuth();
    const dispatch = useDispatch();

    const listener = (event) => {
        let parsedData;

        try {
            parsedData = JSON.parse(event.data);
        } catch (e) {
            parsedData = {};
        }

        if (parsedData.type === 'csc-configuration') {
            const {
                customerIds,
                impersonateUserId,
                ...configuration
            } = parsedData.configuration;

            dispatch(setConfiguration(
                {
                    ...adaptBusinessActivities(configuration),
                    isLoading: false,
                    showExamples: false
                },
                {
                    impersonateUserId
                })
            );

            dispatch(setCustomerIds(
                parseId(customerIds.entityId),
                parseId(customerIds.contactId)
            ));
        }
    };

    React.useEffect(() => {
        if (globalThis.location === globalThis.parent.location) {
            dispatch(setConfiguration({
                isStandalone: true,
                isLoading: false,
                showExamples: globalThis.location.origin.includes('localhost')
            }));

            return () => {};
        }

        globalThis.addEventListener('message', listener);

        return () => {
            globalThis.removeEventListener('message', listener);
        };
    }, []);

    React.useEffect(() => {
        if (authState && authState.isAuthenticated) {
            postLoadedMessage();
        }
    }, [authState]);

    return children;
};
